<template>
    <footer class="Footer mt-auto bg-white dark:bg-surface-card">
        <div v-if="!isBislaCommunity" class="container py-16">
            <!-- Main Footer Content -->
            <div class="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                <!-- Logo & Social -->
                <div class="space-y-6">
                    <div class="relative h-9 w-44">
                        <NuxtLink to="/">
                            <img class="dark:brightness-0 dark:invert" alt="GROWNi logo" loading="lazy" src="/images/partneri/logo-growni.svg" />
                        </NuxtLink>
                    </div>
                    <FooterSocialsLinks />
                    <div v-if="isLoggedIn">
                        <CButton class="rounded-md" icon="heart-outline" :to="{ name: 'podpor-nas' }" variant="pink">
                            <span class="whitespace-nowrap uppercase">Podpor nás</span>
                        </CButton>
                    </div>
                </div>

                <!-- Pre jednotlivcov -->
                <div class="space-y-4">
                    <FooterTitle>Pre jednotlivcov</FooterTitle>
                    <FooterLink inline :to="{ name: 'mentori' }">Nájdi mentora</FooterLink>
                    <FooterLink inline :to="{ name: 'mentoring' }">Ako funguje mentoring</FooterLink>
                    <FooterLink inline :to="{ name: 'dobrovolnictvo' }">Dobrovoľníctvo</FooterLink>
                    <FooterLink inline :to="{ name: 'dobrovolnictvo-dobrovolnicke-projekty' }"
                        >Dobrovoľnícke ponuky</FooterLink
                    >
                    <FooterLink inline :to="{ name: 'praca' }">Práca a stáže</FooterLink>
                    <FooterLink inline to="/staze">Stáže pre študentov</FooterLink>
                    <FooterLink inline :to="{ name: 'sebapoznanie' }">Sebapoznanie</FooterLink>
                    <FooterLink inline :to="{ name: 'vzdelavanie' }">Vzdelávanie</FooterLink>
                    <FooterLink inline :to="{ name: 'kruzky' }">Krúžky</FooterLink>
                    <FooterLink inline :to="{ name: 'diskusie' }">Diskusie</FooterLink>
                </div>

                <!-- Pre organizácie -->
                <div class="space-y-4">
                    <FooterTitle>Pre organizácie</FooterTitle>
                    <FooterLink inline :to="{ name: 'ako-pridat-pracovnu-ponuku' }">Zverejniť prácu</FooterLink>
                    <FooterLink inline :to="{ name: 'ako-najst-dobrovolnika' }">Nájsť dobrovoľníka</FooterLink>
                    <FooterLink inline :to="{ name: 'talentbase' }">TalentBase</FooterLink>
                    <FooterLink inline :to="{ name: 'cennik' }">Cenník</FooterLink>
                    <FooterLink inline :to="{ name: 'organizacie' }">Naše organizácie</FooterLink>
                </div>

                <!-- O platforme -->
                <div class="space-y-4">
                    <FooterTitle>O platforme</FooterTitle>
                    <FooterLink inline :to="{ name: 'about' }">O GROWNi</FooterLink>
                    <FooterLink inline to="/changelog">Čo je nové</FooterLink>
                    <FooterLink inline to="/pribehy">Príbehy</FooterLink>
                    <FooterLink inline :to="{ name: 'blog' }">Blog</FooterLink>
                    <FooterLink inline :to="{ name: 'newsletter' }">Newsletter</FooterLink>
                    <FooterLink inline to="/blog/faq">FAQ</FooterLink>
                    <FooterLink inline :to="{ name: 'contact' }">Kontakt</FooterLink>
                    <FooterLink inline :to="{ name: 'media' }">Pre médiá</FooterLink>
                    <FooterLink inline>
                        <CLiveAgentLink id="LAfooterLinkFeedback" text="Feedback" />
                    </FooterLink>
                </div>
            </div>
        </div>

        <!-- Bottom Section -->
        <div class="border-t border-gray-200 dark:border-default bg-gray-50 dark:bg-surface-card">
            <div class="container py-8">
                <!-- Legal Links -->
                <div class="mb-4">
                    <FooterLink
                        class="!inline-block !text-gray-600 dark:!text-gray-400 !mr-8"
                        :to="{ name: 'ochrana-sukromia' }"
                        >Ochrana údajov</FooterLink
                    >
                    <FooterLink class="!inline-block !text-gray-600 dark:!text-gray-400 !mr-8" :to="{ name: 'vop' }"
                        >Podmienky používania</FooterLink
                    >
                    <FooterLink
                        class="!inline-block !text-gray-600 dark:!text-gray-400"
                        :to="{ name: 'pravidla-platformy' }"
                        >Pravidlá platformy</FooterLink
                    >
                </div>

                <!-- Copyright and theme preference -->
                <div class="flex flex-wrap items-center justify-between gap-4">
                    <div class="flex flex-wrap items-center gap-2 text-sm text-gray-600 dark:text-txt-body">
                        <span>&copy; Projekt GROWNi zastrešuje organizácia</span>
                        <a href="https://www.leaf.sk" target="_blank" title="Link na www.leaf.sk">
                            <img
                                alt="Leaf logo"
                                class="h-6 dark:brightness-0 dark:invert"
                                loading="lazy"
                                src="/images/partneri/logo-leaf.png"
                                width="55"
                                height="24"
                            />
                        </a>
                    </div>
                    <CBottomColorModePicker />
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { useApplicationStore } from '@/stores/application'
import FooterLink from '@/components/footer/FooterLink.vue'
import FooterSocialsLinks from '@/components/footer/FooterSocialsLinks.vue'
import FooterTitle from '@/components/footer/FooterTitle.vue'
import CButton from '@/components/ui/CButton.vue'
import CLiveAgentLink from '@/components/ui/CLiveAgentLink.vue'
import { useLiveAgent } from '@/composables/liveAgent/useLiveAgent'

const userStore = useApplicationStore()
const isLoggedIn = computed(() => userStore.getIsLoggedIn)
const isBislaCommunity = ref(false)

const { createLiveAgentButton } = useLiveAgent()

onMounted(() => {
    void createLiveAgentButton('i23st0gv', 'LAfooterLinkFeedback')
})

const trackReportUser = () => {
    console.log('Tracking report user from footer')
}
</script>

<style lang="postcss">
/* Simplified footer styles */
</style>
